module.exports = __webpack_public_path__ + "static/media/Jawbreak-Sans.08a9812f.ttf";